export const tableHeadConfig = [
  { id: 2, label: 'Location' },
  { id: 3, label: 'Expiration Date' },
  { id: 4, label: 'Sublocation' },
  { id: 5, label: 'Contained In' },
  { id: 6, label: 'Note' },
  { id: 7, label: 'Status' },
  { id: 8, label: 'Min QTY' },
  { id: 9, label: 'BAA', footnote: '[1]' },
  { id: 10, label: 'Current QTY' },
  { id: 11, label: 'Location QTY' }
];
